import { layout } from '~/tools/layout';
import { palette } from './palette';

// TODO: Revisit these overrides. Can this be handled differently?
// Does this need to be global?
export const legacyOverrides = {
  MuiStepIcon: {
    styleOverrides: {
      root: {
        color: '#939393',
        '&.Mui-completed': {
          color: palette.primary.main,
        },
        '&.Mui-active': {
          color: palette.primary.main,
        },
      },
      active: {},
      completed: {},
    },
  },
};

export const overrides = {
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: layout.pxToRem(14),
        '@media (min-width: 600px)': {
          fontSize: layout.pxToRem(14),
          minWidth: layout.pxToRem(160), // minWidth changed in the mui v5, this override will keep the same style
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        // Fix input fontSize
        fontSize: layout.pxToRem(16),
        letterSpacing: 'normal',
      },
    },
  },
  // The body font size has changed from theme.typography.body2 to theme.typography.body1,
  // to return to the previous size, you can override it in the theme:
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontSize: '0.875rem',
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
      },
    },
  },
  // In material-ui v5, the theme/palette is affecting the alert component,
  // we need to override the colors using the desired values.
  MuiAlert: {
    styleOverrides: {
      outlinedSuccess: {
        color: '#1e4620',
        borderColor: '#4caf50',
        '& .MuiAlert-icon': {
          color: palette.success.main,
        },
      },
      outlinedError: {
        color: '#5f2120',
        borderColor: '#ef5350',
        '& .MuiAlert-icon': {
          color: palette.error.main,
        },
      },
      outlinedWarning: {
        color: '#663c00',
        borderColor: '#ff9800',
        '& .MuiAlert-icon': {
          color: '#ed6c02',
        },
      },
      outlinedInfo: {
        color: '#014361',
        borderColor: '#03a9f4',
        '& .MuiAlert-icon': {
          color: palette.info.main,
        },
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: 'red',
      },
    },
  },
};
